<template>
  <div class="container">
    <div class="card">
        <div> 
          <router-link to="/">
            <img alt="back" src="../assets/back-primary.svg" class="card-img"/>
          </router-link>
          <span class="card-title">
              Registrati
          </span>
        </div> 
        <b-form @submit="submit" class="input">
            <b-form-input
                id="nome"
                v-model="nome"
                type="text"
                required
                placeholder="Nome"
            ></b-form-input>
            <b-form-input
                id="cognome"
                v-model="cognome"
                type="text"
                required
                placeholder="Cognome"
            ></b-form-input>
            <b-form-input
                id="codice_fiscale"
                v-model="codice_fiscale"
                type="text"
                required
                placeholder="Codice Fiscale"
            ></b-form-input>
            <b-form-input
                id="email"
                v-model="email"
                type="email"
                required
                placeholder="Email"
            ></b-form-input>
            <b-form-input
                id="password"
                v-model="password"
                type="password"
                required
                placeholder="Password"
            ></b-form-input>
            <div class="button">
                <b-button block type="submit" variant="success">Registrati</b-button>
            </div>
        </b-form>
        <div class="signup" @click="login">
          <span>
            Hai gia un account? 
            <br />
            Clicca qui per fare il login
          </span>
        </div>
    </div>
  </div>
  
</template>

<script>

export default {
  name: "SignupStudio",
  data () {
    return {
      password: "",
      email: "",
      nome: "",
      cognome: "",
      codice_fiscale: ""
    }
  },
  methods: {
    login: function() {
        this.$emit('login');
    },
    submit: function(evt){
      evt.preventDefault()
      this.$axios
      .post( this.$apibase + '/api/users/', {   
        'first_name': this.nome,
        'last_name': this.cognome,
        'username': this.email,
        'email': this.email,
        "unique_id": this.codice_fiscale,
        'password': this.password,
        'is_verified': false,
        'is_active': true,
        'groups': []
      })
      .then(() => {
        this.$axios
        .post( this.$apibase + '/auth/obtain_token/', {        
          'username': this.email,
          'password': this.password,
        })
        .then((response) => {
          localStorage.setItem('access_token', response.data.token);
          let user = {
            'full_name': this.nome + ' ' + this.cognome,
            'user_type': null,
            'is_verified': false
          }
          this.$store.dispatch("setUser", user);
          window.dispatchEvent(new CustomEvent('setUsername'));
          this.$router.push('/nuovo-utente')    
        })
        .catch((e) => {
          console.log(e.response)
        })
      })
      .catch((e)=>{
        console.log(e.response)
        this.$store.dispatch('setAlert', {message: "Qualcosa è andato storto durante la tua richiesta. Controlla che i dati forniti siano corretti e riprova.", type: 'danger'});
      })
    }
  }
};
</script>

<style scoped>
  .container {
    text-align: center;
    padding-top: 100px;
  }
  .card{    
    width: 400px;
    display: inline-flex;
    height: 500px;
    box-shadow: 0 0 5px #6abf61;
    padding: 80px 50px;
    text-align: center;
    align-items: center;    
  }
  .card-title{
    font-size: 21px;
    font-weight: bold;
    float: left;
    padding-left: 10px;
  }
  .card-img{
    width:30px;
    float: left;
  }
  .input{
    padding-top: 40px;
    width: 100%;
  }
  .button {
    padding-top: 20px;
    width: 100%;
  }
  .signup{
    padding-top:20px;
    font-size: small;
    cursor: pointer;
  }
</style>